function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsContacts = function SvgSettingsContacts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.75,21.88v2.24h.7a.43.43,0,0,1,.43.43V26a.43.43,0,0,1-.43.43h-.7v2.24h.7a.43.43,0,0,1,.43.43v1.4a.43.43,0,0,1-.43.43h-.7v1.68a1.69,1.69,0,0,1-1.69,1.69H18.81a1.69,1.69,0,0,1-1.69-1.69V17.94a1.69,1.69,0,0,1,1.69-1.69H30.06a1.69,1.69,0,0,1,1.69,1.69v1.68h.7a.43.43,0,0,1,.43.43v1.4a.43.43,0,0,1-.43.43ZM28.38,28.4a2.21,2.21,0,0,0-2.37-2h-.17a3.84,3.84,0,0,1-1.4.28,3.8,3.8,0,0,1-1.4-.28h-.18a2.21,2.21,0,0,0-2.36,2v.68a.74.74,0,0,0,.79.67h6.3a.74.74,0,0,0,.79-.67ZM22.19,23a2.25,2.25,0,1,0,2.25-2.25A2.25,2.25,0,0,0,22.19,23Z",
    style: {
      fill: "#666"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsContacts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-contacts.e9552976.svg";
export { ForwardRef as ReactComponent };